<template>
    <div class="mx-sm-1 mt-9">
        <div class="modal fade" id="modaldemo8">
            <div class="modal-dialog modal-dialog-centered text-center" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">{{ save ? 'Création d\'un contact' : 'Modification d\'un contact' }}
                        </h6><button id="closeButton" aria-label="Close" class="btn-close" data-bs-dismiss="modal"><span
                                aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="card overflow-hidden">
                                <div class="card-body">
                                    <ValidationObserver v-slot="{ invalid }">
                                        <form @submit.prevent="submit" class="">
                                            <div class="form-row">
                                                <div class="form-group col-md-6 mb-0">
                                                    <ValidationProvider name="Nom" rules="required" v-slot="{ errors }">
                                                        <label class="form-label">NOM <span
                                                                class="text-danger">*</span></label>
                                                        <input type="text" class="form-control" id="nom"
                                                            v-model="payload.nom" placeholder="saisir le nom">
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="form-group col-md-6 mb-0">
                                                    <ValidationProvider name="Prenoms" rules="required"
                                                        v-slot="{ errors }">
                                                        <label class="form-label">PRENOMS <span
                                                                class="text-danger">*</span></label>
                                                        <input type="text" class="form-control" id="prenom"
                                                            v-model="payload.prenom" placeholder="saisir le prenom">
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12 mb-0">
                                                    <ValidationProvider name="autrePrenom" rules=""
                                                        v-slot="{ errors }">
                                                        <label class="form-label">AUTRE PRENOMS </label>
                                                        <input type="text" class="form-control" id="autrePrenom"
                                                            v-model="payload.autrePrenom"
                                                            placeholder="saisir les autres prenoms">
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6 mb-0">
                                                    <ValidationProvider name="contact" rules="required|integer"
                                                        v-slot="{ errors }">
                                                        <label class="form-label">CONTACT <span
                                                                class="text-danger">*</span></label>
                                                        <input type="text" class="form-control" id="libelle"
                                                            v-model="payload.contact" placeholder="saisir le contact">
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="form-group col-md-6 mb-0">
                                                    <ValidationProvider name="courriel" rules="required|email"
                                                        v-slot="{ errors }">
                                                        <label class="form-label">COURRIEL <span
                                                                class="text-danger">*</span></label>
                                                        <input type="text" class="form-control" id="libelle"
                                                            v-model="payload.courriel" placeholder="saisir le courriel">
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12 mb-0">
                                                    <ValidationProvider name="Organisation" rules="" v-slot="{ errors }">
                                                        <label class="form-label">ORGANISATION </label>
                                                        <multi-select class="col-sm" :options="organisations"
                                                            v-model="payload.organisation" :searchable="true"
                                                            :close-on-select="true" :show-labels="false"
                                                            :custom-label="v => v.organisation"
                                                            placeholder="Choisir l'organisation " label="organisation"
                                                            track-by="organisation"></multi-select>

                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12 mb-0">
                                                    <ValidationProvider name="Poste" rules="" v-slot="{ errors }">
                                                        <label class="form-label">POSTE </label>
                                                        <multi-select class="col-sm" :options="postes"
                                                            v-model="payload.poste" :searchable="true"
                                                            :close-on-select="true" :show-labels="false"
                                                            :custom-label="v => v.libellePoste"
                                                            placeholder="Choisir le poste " label="libellePoste"
                                                            track-by="idPoste"></multi-select>

                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12 mb-0">
                                                    <ValidationProvider name="Superviseur" rules="" v-slot="{ errors }">
                                                        <label class="form-label">SUPERVISEUR </label>
                                                        <multi-select class="col-sm" :options="contacts"
                                                            v-model="payload.superviseur" :searchable="true"
                                                            :close-on-select="true" :show-labels="false"
                                                            :custom-label="v => v.nom + ' ' + v.prenom"
                                                            placeholder="Choisir le superviseur " label="nom"
                                                            track-by="idContact"></multi-select>

                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12 mb-0">
                                                    <ValidationProvider name="trigramme" rules="required|max:5"
                                                        v-slot="{ errors }">
                                                        <label class="form-label">TRIGRAMME <span
                                                                class="text-danger">*</span></label>
                                                        <input type="text" class="form-control" id="trigramme"
                                                            v-model="payload.trigramme"
                                                            @input="payload.trigramme = payload.trigramme?.toUpperCase()"
                                                            placeholder="saisir le trigramme" autocomplete="libelle">
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="form-footer mt-2 d-flex justify-content-around">
                                                <div>
                                                    <button class="btn btn-success mt-4 mb-0" :disabled="invalid"
                                                        v-if="save"><span class="fe fe-check"></span>
                                                        Enregistrer</button>
                                                    <button class="btn btn-success mt-4 mb-0" :disabled="invalid"
                                                        v-else><span class="fe fe-check"></span> Modifier</button>
                                                </div>
                                                <div>
                                                    <a class="btn btn-danger mt-4 mb-0 text-end"
                                                        data-bs-dismiss="modal">Annuler</a>
                                                </div>
                                            </div>
                                        </form>
                                    </ValidationObserver>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="modal-footer">
                        <button class="btn btn-primary">Save changes</button> <button class="btn btn-light"
                            data-bs-dismiss="modal">Fermer</button>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="page-header">
            <h1 class="page-title fw-bold">Les Contacts</h1>
            <div>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de
                                bord</a></router-link></li>
                    <li class="breadcrumb-item active" aria-current="page"><router-link
                            :to="{ name: 'contactsPages' }"><a>Les Contacts</a></router-link></li>
                </ol>
            </div>
            <a class="modal-effect btn btn-success-light d-grid mb-3" data-bs-effect="effect-super-scaled"
                data-bs-toggle="modal" href="#modaldemo8">Ajouter</a>
        </div>
        <div class="row mb-3">
            <multi-select class="col-sm-3" @select="o => o.used = true" :options="columns.filter(o => !o.used)"
                :custom-label="v => v.description" placeholder="Filtrer par " label="name"
                track-by="name"></multi-select>
            <multi-select class="col-sm-3" :options="pagination" deselect-label="Sélectionné"
                :custom-label="v => v.description" placeholder="Eléments par page " label="value" track-by="value"
                :multiple="false" v-model="page"></multi-select>
            <div class="col-sm text-sm-right">
                <div class="dt-buttons btn-group">
                    <button aria-controls="kt_table_1" class="btn btn-outline-dark style_btn rounded-0" tabindex="1"
                        type="button" @click.prevent="onSearch"><span><i class="fe fe-search"></i>
                            Rechercher</span></button>
                    <!-- <button aria-controls="kt_table_1" class="btn btn-light style_btn rounded-0" tabindex="2"
                        type="button" @click.prevent="onCsv"><span><i class="fa fa-print"></i>
                            Exporter</span></button> -->
                </div>
            </div>
        </div>
        <div class="row">
            <div v-for="(item, index) in filters" :key="`filter${index}`" class="form-group col-sm">
                <div class="input-group">
                    <select v-if="item.options" v-model="item.value" class="form-control">
                        <option v-for="(obj, i) in item.options" :key="i" :value="obj.key">{{ obj.value }}</option>
                    </select>
                    <input v-else :type="item.type" class="form-control"
                        :placeholder="`Recherche de ${item.description}`" v-model="item.value">
                    <div class="input-group-append">
                        <button class="btn btn-danger" type="button" @click="item.used = false"><i
                                class="fe fe-trash"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Liste</h3>
                        <div class="card-options">
                            <SearchInputAll></SearchInputAll>
                            <button class="btn text-primary btn-sm" @click="onSearch" data-bs-toggle="tooltip"
                                data-bs-original-title="Modifier"><span class="fe fe-search fs-18"></span></button>
                        </div>
                    </div>
                    <div class="card-body">
                        <table id="data-table"
                            class="table table-responsive table-hover table-bordered text-nowrap mb-0">
                            <thead class="border-top danger02">
                                <tr class="fw-bold">
                                    <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">N</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Creer le</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                        IdContact</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Nom</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Prenoms</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Autre Prenoms</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Contact</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Courriel</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Organisation</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Poste</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold">
                                        Trigramme</th>
                                    <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">Actions</th>
                                </tr>
                            </thead>
                            <tbody v-if="filtersItems[0]" id="myTable1">
                                <tr v-for="(item, index) in filtersItems" :key="index" class="border-bottom">
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td>{{ item?.createdAt | moment('LLLL') }}</td>
                                    <td>{{ item?.idContact }}</td>
                                    <td>{{ item?.nom }}</td>
                                    <td>{{ item?.prenom }}</td>
                                    <td>{{ item?.autrePrenom }}</td>
                                    <td>{{ item?.contact }}</td>
                                    <td>{{ item?.courriel }}</td>
                                    <td>{{ item?.organisation?.organisation }}</td>
                                    <td>{{ item?.poste?.libellePoste }}</td>
                                    <td>{{ item?.trigramme }}</td>
                                    <td>
                                        <div class="g-2">
                                            <button class="btn text-primary btn-sm" @click="edit(item)"
                                                data-bs-effect="effect-super-scaled" data-bs-toggle="modal"
                                                href="#modaldemo8"><span class="fe fe-edit fs-18"></span></button>
                                            <button class="btn text-danger btn-sm" @click="drop(item)"
                                                data-bs-toggle="tooltip" data-bs-original-title="Supprimer"><span
                                                    class="fe fe-trash-2 fs-18"></span></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr class="primary02">
                                    <td colspan="13" class="text-center">Aucun contact trouvé</td>
                                </tr>
                            </tbody>
                        </table>
                        <paginate :records="items.totalElements || 0" v-model="items.number" :per-page="items.size"
                        :options="{ theme: 'bootstrap4', edgeNavigation: true, texts: { count: `{from} à {to} de {count} éléments|{count} éléments|Un élément`, first: '<<<', last: '>>>' } }"
                        @paginate="onSearch" />
                    </div>
                </div>
            </div>
            <!-- COL END -->
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4">
                <div class="card overflow-hidden">
                    <div class="card-header">
                        <h3 class="card-title">{{ save ? 'Création d\'un contact' : 'Modification d\'un contact' }}</h3>
                    </div>
                    <div class="card-body">
                        <ValidationObserver v-slot="{ invalid }">
                            <form @submit.prevent="submit" class="">
                                <div class="form-row">
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="Nom" rules="required" v-slot="{ errors }">
                                            <label class="form-label">NOM <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="nom" v-model="payload.nom"
                                                placeholder="saisir le nom">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="Prenoms" rules="required" v-slot="{ errors }">
                                            <label class="form-label">PRENOMS <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="prenom" v-model="payload.prenom"
                                                placeholder="saisir le prenom">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-12 mb-0">
                                        <ValidationProvider name="autrePrenom" rules="required" v-slot="{ errors }">
                                            <label class="form-label">AUTRE PRENOMS </label>
                                            <input type="text" class="form-control" id="autrePrenom"
                                                v-model="payload.autrePrenom" placeholder="saisir les autres prenoms">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="contact" rules="required" v-slot="{ errors }">
                                            <label class="form-label">CONTACT <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="libelle"
                                                v-model="payload.contact" placeholder="saisir le contact">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="courriel" rules="required" v-slot="{ errors }">
                                            <label class="form-label">COURRIEL <span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="libelle"
                                                v-model="payload.courriel" placeholder="saisir le courriel">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="departement" rules="required" v-slot="{ errors }">
                                            <label class="form-label">DEPARTEMENT <span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="libelle"
                                                v-model="payload.departement" placeholder="saisir le departement">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="organisation" rules="required" v-slot="{ errors }">
                                            <label class="form-label">ORGANISATION <span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="libelle"
                                                v-model="payload.organisation" placeholder="saisir l'organisation">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="pole" rules="required" v-slot="{ errors }">
                                            <label class="form-label">POLE <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="pole" v-model="payload.pole"
                                                placeholder="saisir le pole">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="poste" rules="required" v-slot="{ errors }">
                                            <label class="form-label">POSTE <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="poste" v-model="payload.poste"
                                                placeholder="saisir le poste">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-12 mb-0">
                                        <ValidationProvider name="trigramme" rules="required" v-slot="{ errors }">
                                            <label class="form-label">TRIGRAMME <span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="trigramme"
                                                v-model="payload.trigramme" placeholder="saisir le trigramme"
                                                autocomplete="libelle">
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-footer mt-2 d-flex justify-content-around">
                                    <div>
                                        <button class="btn btn-success mt-4 mb-0" :disabled="invalid" v-if="save"><span
                                                class="fe fe-check"></span> Enregistrer</button>
                                        <button class="btn btn-success mt-4 mb-0" :disabled="invalid" v-else><span
                                                class="fe fe-check"></span> Modifier</button>
                                    </div>
                                    <div>
                                        <a href="javascript:void(0)"
                                            class="btn btn-danger mt-4 mb-0 text-end">Annuler</a>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { reduce } from "lodash";
export default {
    name: "Contacts",
    data() {
        return {
            loading: false,
            payload: { id: "", libelle: "" }, save: true,
            columns: [
                { name: 'idContact', description: 'Contact ID', type: 'text', used: false },
                { name: 'nom', description: 'Nom', type: 'text', used: false },
                { name: 'prenom', description: 'Prenoms', type: 'text', used: false },
                { name: 'contact', description: 'Contact', type: 'text', used: false },
                { name: 'trigramme', description: 'Trigramme', type: 'text', used: false },
                { name: 'courriel', description: 'Courriel', type: 'text', used: false },
                { name: 'organisation', description: 'Organisation', type: 'text', used: false },
                { name: 'libellePoste', description: 'Libelle poste', type: 'text', used: false },
                { name: 'superieurNom', description: 'Nom Superieur', type: 'text', used: false },
                { name: 'superieurPrenom', description: 'Prenom Superieur', type: 'text', used: false },
            ],
            page: { name: 'size', description: '10 par page', value: 10, type: 'number', used: false },
            pagination: [
                { name: 'size', description: '10 par page', value: 10, type: 'number', used: false },
                { name: 'size', description: '20 par page', value: 20, type: 'number', used: false },
                { name: 'size', description: '30 par page', value: 30, type: 'number', used: false },
                { name: 'size', description: '40 par page', value: 40, type: 'number', used: false },
                { name: 'size', description: '50 par page', value: 50, type: 'number', used: false },
                { name: 'size', description: '60 par page', value: 60, type: 'number', used: false },
                { name: 'size', description: '70 par page', value: 70, type: 'number', used: false },
            ],
            exportations: [
                { name: 'ACCEPTED', description: 'Acceptée' },
                { name: 'REFUSED', description: 'Refusée' },
                { name: 'PENDING', description: 'En Cours' },
                { name: 'DIFFERED', description: 'Différée' },
                { name: 'PROCESSED', description: 'En Traitement' },
            ],
            reinit: false,
        }
    },
    watch: {
        page: {
            deep: true,
            immediate: true,
            handler(value) {
                this.reinit = true;
                this.onSearch();
            }
        }
    },
    computed: {
        ...mapGetters({ items: 'contact/list' }),
        ...mapGetters({ contacts: 'contact/list' }),
        ...mapGetters({ postes: 'poste/list' }),
        ...mapGetters({ organisations: 'organisation/list' }),
        filtersItems() {
            return this.items?.content || [];
        },
        filters() {
            return this.columns.filter(o => o.used);
        },
        option() {
            return reduce(this.filters, (acc, item) => (acc[item.name] = item.value, acc), {})
        },
    },
    methods: {
        ...mapActions('contact', ['all', 'save']),
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            //Réinitialiser la page quand le nombre de page change
            if (this.reinit){
                this.option.page = 0;
                this.reinit = false;
            }
            if(this.page) this.option.size = this.page.value;
            this.$router.push({ query: this.option }).catch(() => { });
            this.$store.dispatch('contact/all', this.option).finally(() => this.$loading(false));
        },
        freeData() {
            this.save = true;
            this.payload = { id: "", libelle: "" };
        },
        submit() {
            this.$loading(true);
            this.loading = true;
            if (this.save) {
                console.log(this.payload);
                this.$http.post('/contacts', this.payload)
                    .then(({ data }) => {
                        if (data.idContact) {
                            // this.$swal.fire('Information', 'Permission enregistré avec succès.', 'success').then(() => {
                            //     this.payload = {libelle: ""};
                            // });
                            swal('Information!', "Contact cree avec succes", 'success');
                        } else {
                            swal('Information!', "Erreur lors de l'ajout du contact.", 'error');
                        }
                        this.freeData();
                        this.onSearch();
                        this.save = true;
                        this.$loading(false);
                        document.getElementById("closeButton").click();
                    }).catch((error) => {
                        this.$loading(false);
                        swal('Erreur!', 'Une erreur est survenue lors de l\'enregistrement du contact.', 'error');
                    });
            } else {
                console.log("Editer", this.payload);
                this.$http.put('/contacts/' + this.payload.idContact, this.payload)
                    .then(({ data }) => {
                        console.log(data);
                        if (data.status) {
                            swal('Information!', data.message, 'success');
                        } else {
                            swal('Information!', data.message, 'error');
                        }
                        this.freeData();
                        this.onSearch();
                        this.save = true;
                        this.$loading(false);
                        document.getElementById("closeButton").click();
                    }).catch((error) => {
                        this.$loading(false);
                        swal('Erreur!', 'Une erreur est survenue lors de la modification du contact.', 'error');
                    });
            }
        },
        edit(value) {
            this.$loading(true);
            this.save = false;
            this.payload = { ...value };
            this.$loading(false);
        },
        drop(item) {
            const self = this;
            swal({
                title: "Vous voulez continuer?",
                text: "La selection sera supprimee!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#FF0000",
                cancelButtonColor: "#d33",
                confirmButtonText: "Oui, supprimer!",
                cancelButtonText: "Annuler!"
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.delete('/contacts/' + item.idContact)
                        .then(({ data, status }) => {
                            if (status === 200 || status === 201) {
                                swal('Information!', "Contact supprime", 'success');
                            } else {
                                swal('Information!', "Erreur lors de la suppression du contact", 'error');
                            }
                            self.$loading(false);
                            self.onSearch();
                        }).catch((error) => {
                            self.$loading(false);
                            swal('Erreur!', 'Une erreur est survenue lors de la suppression du contact.', 'error');
                        });
                }
            });

        },
    },
    created() {
        this.onSearch();
        this.$store.dispatch('organisation/allData');
        this.$store.dispatch('poste/allData');
        this.$store.dispatch('contact/allData');
    }
}
</script>

<style></style>